/**
 * Filled by data from API call
 * /umbraco/delivery/api/v2/content?filter=contentType:numericValueTranslationItem
 */
export default class NumericValueTranslationItem {
    fetchKey: string;
    format0: string | null;
    format1: string | null;
    formatN: string | null;
    
    constructor(fetchKey: string, format0: string | null, format1: string | null, formatN: string | null) {
        this.fetchKey = fetchKey;
        this.format0 = format0;
        this.format1 = format1;
        this.formatN = formatN;
    }
}

export interface NumericValueTranslationItemProperties {
    numericValueTranslationItem: NumericValueTranslationItem | undefined;
}